import { render } from "./ThePaymentsContainer.vue?vue&type=template&id=6dcbb7c2"
import script from "./ThePaymentsContainer.vue?vue&type=script&lang=js"
export * from "./ThePaymentsContainer.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__